<div [class.hide]="!loading" class="spinner-wrapper">
	<shakespeare-spinning-loader [rotating]="true"></shakespeare-spinning-loader>
</div>
